

// import React, { useContext } from "react";
// import Swal from "sweetalert2";
// import { BsWhatsapp } from "react-icons/bs";
// import { FiCopy } from "react-icons/fi";
// import { LanguageContext } from "../Components/LanguageContext";
// // import "./ReferUI.css"; 

// const Refer = ({ user }) => {
//   const { language } = useContext(LanguageContext);

//   if (!user) return null;

//   const copyCode = () => {
//     navigator.clipboard.writeText(user.referral_code);
//     Swal.fire({
//       icon: "success",
//       title: "Referral Code Copied",
//       showConfirmButton: false,
//       timer: 1000,
//     });
//   };

//   // const shareText = `PlayAPNAONE and earn daily! Join using my code: ${user.referral_code} \nLink: https://apnaone.com/login/${user.referral_code}`;
// const shareText = `🔥 Hello Dost 👋

// Apni Site APNAONE par Game Khelo aur Daily Paisa Jeeto 💸

// 🎁 Referral Code se Join karo aur pao 3% Referral Commission ka fayda.

// 🕹️ Fast Deposit • Fast Withdraw • Real Cash Games

// 👉 Join Now:
// https://apnaone.com/login/${user.referral_code}

// 🎯 Referral Code: ${user.referral_code}`;
//   return (
//     <div className="refer-page-wrapper leftContainer mt-5 pt-5">
//       <div className="refer-main-container">
        
//         {/* Title Section */}
//         <div className="refer-title-section">
//           <h1>Invite & Earn</h1>
//           <p>Share your code and get 3% of your friend's winnings!</p>
//         </div>

//         {/* Unique Referral Code Card */}
//         <div className="referral-code-card">
//           <label>YOUR UNIQUE REFERRAL CODE</label>
//           <div className="code-row">
//             <div className="dashed-code-box">
//               {user.referral_code}
//             </div>
//             <button className="copy-btn-blue" onClick={copyCode}>
//               <FiCopy /> Copy
//             </button>
//           </div>
//         </div>

//         {/* WhatsApp Button */}
//         <a 
//           href={`whatsapp://send?text=${encodeURIComponent(shareText)}`} 
//           className="whatsapp-btn-full"
//         >
//           <BsWhatsapp className="wa-icon" /> WhatsApp
//         </a>

//         {/* Stats Divider */}
//         <div className="stats-divider">
//           <div className="divider-line"></div>
//           <span>YOUR STATS</span>
//           <div className="divider-line"></div>
//         </div>

//         {/* Stats Grid */}
//         <div className="refer-stats-grid">
//           <div className="stat-box purple-box">
//             <div className="stat-content">
//               <h2>{user.referral_user?.length || 0}</h2>
//               <p>Total Players</p>
//             </div>
//             <img src="/images/trophy-bg.png" alt="" className="box-bg-icon" />
//           </div>

//           <div className="stat-box orange-box">
//             <div className="stat-content">
//               <h2>₹{user.referral_earning || 0}</h2>
//               <p>Total Earnings</p>
//             </div>
//             <img src="/images/money-bag.png" alt="" className="box-bg-icon" />
//           </div>
//         </div>

//         {/* How It Works */}
//         <div className="how-it-works-card mb-5">
//           <h3><span className="info-icon">🛈</span> How It Works</h3>
          
//           <div className="step-row">
//             <div className="step-number">01</div>
//             <p>You can refer and <strong>Earn 3%</strong> of your referral winning, every time.</p>
//           </div>

//           <div className="step-row">
//             <div className="step-number">02</div>
//             <p>If your player wins <strong>₹10,000</strong>, you instantly get <strong>₹300</strong> in your wallet.</p>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default Refer;


import React, { useContext } from "react";
import Swal from "sweetalert2";
import { BsWhatsapp } from "react-icons/bs";
import { FiCopy } from "react-icons/fi";
import { LanguageContext } from "../Components/LanguageContext";
// import "../css/ReferPremium.css"; // Newly added dedicated premium stylesheet

const Refer = ({ user }) => {
  const { language } = useContext(LanguageContext);

  if (!user) return null;

  const copyCode = () => {
    navigator.clipboard.writeText(user.referral_code);
    Swal.fire({
      icon: "success",
      title: "Referral Code Copied",
      showConfirmButton: false,
      timer: 1000,
    });
  };

  const shareText = `🔥 Hello Dost 👋

Apni Site APNAONE par Game Khelo aur Daily Paisa Jeeto 💸

🎁 Referral Code se Join karo aur pao 3% Referral Commission ka fayda.

🕹️ Fast Deposit • Fast Withdraw • Real Cash Games

👉 Join Now:
https://apnaone.com/login/${user.referral_code}

🎯 Referral Code: ${user.referral_code}`;

  return (
    <div className="refer-page-wrapper leftContainer mt-5 pt-5 refer-premium-root">
      <div className="refer-main-container">
        
        {/* Title Section */}
        <div className="refer-title-section">
          <h1>Invite & Earn</h1>
          <p>Share your code and get 3% of your friend's winnings!</p>
        </div>

        {/* Unique Referral Code Card */}
        <div className="referral-code-card premium-glass-card">
          <label>YOUR UNIQUE REFERRAL CODE</label>
          <div className="code-row">
            <div className="dashed-code-box premium-code-display">
              {user.referral_code}
            </div>
            <button className="copy-btn-blue premium-btn-secondary" onClick={copyCode}>
              <FiCopy /> Copy
            </button>
          </div>
        </div>

        {/* WhatsApp Button */}
        <a 
          href={`whatsapp://send?text=${encodeURIComponent(shareText)}`} 
          className="whatsapp-btn-full premium-whatsapp-btn"
        >
          <BsWhatsapp className="wa-icon" /> Share on WhatsApp
        </a>

        {/* Stats Divider */}
        <div className="stats-divider">
          <div className="divider-line"></div>
          <span>YOUR STATS</span>
          <div className="divider-line"></div>
        </div>

        {/* Stats Grid */}
        <div className="refer-stats-grid">
          <div className="stat-box purple-box premium-stat-card">
            <div className="stat-content">
              <h2>{user.referral_user?.length || 0}</h2>
              <p>Total Players</p>
            </div>
            <img src="/images/trophy-bg.png" alt="" className="box-bg-icon" />
          </div>

          <div className="stat-box orange-box premium-stat-card">
            <div className="stat-content">
              <h2>₹{user.referral_earning || 0}</h2>
              <p>Total Earnings</p>
            </div>
            <img src="/images/money-bag.png" alt="" className="box-bg-icon" />
          </div>
        </div>

        {/* How It Works */}
        <div className="how-it-works-card premium-glass-card mb-5">
          <h3><span className="info-icon">🛈</span> How It Works</h3>
          
          <div className="step-row">
            <div className="step-number premium-step-num">01</div>
            <p>You can refer and <strong>Earn 3%</strong> of your referral winning, every time.</p>
          </div>

          <div className="step-row">
            <div className="step-number premium-step-num">02</div>
            <p>If your player wins <strong>₹10,000</strong>, you instantly get <strong>₹300</strong> in your wallet.</p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Refer;